
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("e7zr1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $dd3b564a2c1c77d9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $dd3b564a2c1c77d9$export$2e2bcd8739ae039 = {
    'fabric.elements.mentions.team.member.50plus': "Team \u2022 \xfcber 50\xa0Mitglieder",
    'fabric.elements.mentions.team.member.50plus.including.you': "Team \u2022 \xfcber 50\xa0Mitglieder, einschlie\xdflich Ihnen",
    'fabric.elements.mentions.team.member.count': "{0, plural, one {Team \u2022 1\xa0Mitglied} other {Team \u2022 {0}\xa0Mitglieder}}",
    'fabric.elements.mentions.team.member.count.including.you': "{0, plural, one {Team \u2022 1\xa0Mitglied, einschlie\xdflich Ihnen} other {Team \u2022 {0}\xa0Mitglieder, einschlie\xdflich Ihnen}}",
    'fabric.elements.mentions.xproduct.mention.description': "Ben\xf6tigt Zugriff auf Confluence",
    'fabric.mention.error.defaultAction': 'Versuchen Sie es in ein paar Sekunden erneut.',
    'fabric.mention.error.defaultHeadline': 'Irgendetwas ist schiefgelaufen',
    'fabric.mention.error.differentText': 'Versuchen Sie, einen anderen Text einzugeben.',
    'fabric.mention.error.loginAgain': 'Loggen Sie sich aus und wieder ein.',
    'fabric.mention.noAccess.label': 'Kein Zugriff',
    'fabric.mention.noAccess.warning': '{name} wird nicht benachrichtigt, da diese Person keinen Zugriff besitzt.',
    'fabric.mention.unknow.user.error': 'Unbekannter Benutzer {userId}'
};

});


//# sourceMappingURL=de.0e52901f.js.map
